<template>
  <div>
    <a :href="cardLink ? cardLink : 'javascript:void(0)'">
      <div class="fs-white-box p-1 hosted-card mt-0 mb-4 overflow-hidden fs-hover-outline-purple flex flex-col bg-1">
        <img class="w-full cover-image" :src="coverImage" style="border-top-left-radius: 16px; border-top-right-radius: 16px;" />

        <div class="flex-auto flex flex-col overflow-y-hidden ">
          <div class="p-4 h-full flex flex-col justify-between overflow-y-hidden">
            <div class="flex-auto flex flex-col overflow-y-hidden">	
              <div class="flex flex-col ht-100 flex-shrink-0">	
                <p class="text-black text-sm SofiaPro-Medium truncate-text-3 mt-1">{{ title}}</p>	
              </div>	
            </div>
            <div class="flex flex-wrap mt-2 mb-4">
              <div class="flex justify-start items-center">
                <div class="h-4">
                  <img class="h-full" :src="`${require('images/defaults/time.svg')}`" />
                </div>
                <div v-if="read_time" class="text-xs pl-2 text-rspurple">{{read_time}} read</div>
                <div v-else class="text-xs pl-2 text-rspurple">5 mins read</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </a>
  </div>
</template>

<script>

  export default {
    props: {
      type: String,
      title: String,
      index: Number,
      coverImage: String,
      cardLink: String,
      read_time: String,
    },
    mounted() {
    },

    data() {
      return {
      };
    },

    methods: {}
      
  };
</script>

<style lang="scss" scoped>
  img.cover-image {
    height: 180px;
    object-fit: cover;
  }

  .hidden{
    display: none !important
  }

  .hosted-card{
    max-width: 310px !important;
    height: 330px !important;
    width: 100%;
    border-radius: 16px;
  }

  .text-card{
    font-family: Poppins;
    font-size: 16px;
    font-weight: 500;
    line-height: 22px;
    letter-spacing: 0em;
    text-align: left;
  }

  .bg-1{
    background-color: #f4f7fa !important;
  }

  .fs-hover-outline-purple:hover {
    box-shadow: inset 0px 0px 0px 1px #8c40e2 !important;
  }

  @responsive {
    .ht-100 {
      height: 100px;
    }
  }
</style>
